<div class="lg-container">

  <article class="stats-wrapper">

    <div class="stats">
      <div class="header-wrapper">
        <h3 class="stats-header" translate>
          LEAD_GENERATION.STATS.TIME_TO_FIRST_CONTACT
        </h3>

      </div>

      <div class="stats-no-data" *ngIf="!dataAvailable">
        <p class="stats-no-data-label" translate>LEAD_GENERATION.STATS.NO_DATA</p>
      </div>

      <div [ngClass]='{"no-data-to-show": !dataAvailable}'>
        <cc-lg-vertical-bar-chart
          [chartsData]="chartData"
          [configMapper]="chartConfigMapper"
        ></cc-lg-vertical-bar-chart>
      </div>

    </div>
  </article>
</div>
